import { createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, vModelText as _vModelText, withDirectives as _withDirectives, resolveComponent as _resolveComponent, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, vShow as _vShow, vModelCheckbox as _vModelCheckbox, withModifiers as _withModifiers, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-83888be8")

_pushScopeId("data-v-83888be8")
const _hoisted_1 = {
  key: 0,
  class: "modal-message-template"
}
const _hoisted_2 = { class: "close-row" }
const _hoisted_3 = {
  key: 0,
  class: "modal-message-template-header"
}
const _hoisted_4 = {
  key: 1,
  class: "modal-message-template-header"
}
const _hoisted_5 = { class: "row" }
const _hoisted_6 = { class: "col-9" }
const _hoisted_7 = { class: "row" }
const _hoisted_8 = { class: "col-12" }
const _hoisted_9 = {
  key: 0,
  class: "col-12 mt-3",
  style: {"margin-top":"12px"}
}
const _hoisted_10 = { class: "input-item-label" }
const _hoisted_11 = {
  key: 1,
  class: "col-12",
  style: {"margin-top":"12px"}
}
const _hoisted_12 = { class: "row" }
const _hoisted_13 = {
  key: 0,
  class: "col-6",
  style: {"padding-inline-end":"6px"}
}
const _hoisted_14 = { key: 0 }
const _hoisted_15 = {
  key: 1,
  class: "col-6",
  style: {"padding-inline-end":"6px"}
}
const _hoisted_16 = { class: "row" }
const _hoisted_17 = { class: "col-12" }
const _hoisted_18 = /*#__PURE__*/_createVNode("i", { class: "caret-custom-icon" }, null, -1)
const _hoisted_19 = {
  key: 2,
  class: "loader",
  style: {"position":"absolute","top":"12px","left":"calc(25% - 12px)"}
}
const _hoisted_20 = {
  class: "col-6",
  style: {"padding-inline-start":"6px"}
}
const _hoisted_21 = { class: "col-12 mt-3" }
const _hoisted_22 = { key: 0 }
const _hoisted_23 = {
  class: "d-flex",
  style: {"max-width":"90%","overflow":"hidden"}
}
const _hoisted_24 = { class: "file-name" }
const _hoisted_25 = { key: 1 }
const _hoisted_26 = {
  class: "d-flex",
  style: {"max-width":"90%","overflow":"hidden"}
}
const _hoisted_27 = { class: "file-name" }
const _hoisted_28 = { class: "row template-option" }
const _hoisted_29 = { class: "col-12" }
const _hoisted_30 = { class: "checkbox-title" }
const _hoisted_31 = { class: "row" }
const _hoisted_32 = { class: "sms-settings col-12" }
const _hoisted_33 = {
  class: "row",
  style: {"padding-inline-start":"28px"}
}
const _hoisted_34 = { class: "col-12" }
const _hoisted_35 = { class: "input-item-label" }
const _hoisted_36 = {
  class: "row template-option",
  style: {"margin-block":"2px 20px"}
}
const _hoisted_37 = { class: "col-12" }
const _hoisted_38 = { class: "checkbox-title" }
const _hoisted_39 = { class: "row" }
const _hoisted_40 = { class: "email-settings col-12" }
const _hoisted_41 = {
  class: "row",
  style: {"padding-inline-start":"28px"}
}
const _hoisted_42 = {
  class: "col-6",
  style: {"padding-inline-end":"6px"}
}
const _hoisted_43 = { class: "input-item-label" }
const _hoisted_44 = {
  class: "col-6",
  style: {"padding-inline-start":"6px"}
}
const _hoisted_45 = { class: "input-item-label" }
const _hoisted_46 = {
  class: "row",
  style: {"margin-bottom":"8px"}
}
const _hoisted_47 = { class: "col-12" }
const _hoisted_48 = {
  class: "row",
  style: {"padding-inline-start":"28px"}
}
const _hoisted_49 = { class: "col-12 d-flex" }
const _hoisted_50 = { class: "force-rtl-title" }
const _hoisted_51 = { class: "footer-template-actions" }
const _hoisted_52 = {
  class: "save-send-button",
  type: "submit"
}
const _hoisted_53 = {
  class: "col-3",
  style: {"padding-inline-start":"5px"}
}
const _hoisted_54 = { class: "row" }
const _hoisted_55 = { class: "col-12" }
const _hoisted_56 = { class: "template-key-title" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_Multiselect = _resolveComponent("Multiselect")
  const _component_CheckBoxInput = _resolveComponent("CheckBoxInput")
  const _component_OverlayModal = _resolveComponent("OverlayModal")

  return (_openBlock(), _createBlock(_component_OverlayModal, {
    isOpen: _ctx.isOpen,
    "onUpdate:isOpen": _cache[19] || (_cache[19] = ($event: any) => (_ctx.isOpen = $event)),
    closeOnClick: false,
    style: {"max-width":"unset!important"},
    modalWidth: 730
  }, {
    default: _withId(() => [
      _createVNode("form", {
        onSubmit: _cache[18] || (_cache[18] = _withModifiers(($event: any) => (_ctx.submitForm($event)), ["prevent"])),
        ref: "templateForm",
        novalidate: ""
      }, [
        (_ctx.template)
          ? (_openBlock(), _createBlock("div", _hoisted_1, [
              _createVNode("div", _hoisted_2, [
                _createVNode("span", {
                  class: "icon-f icon-delete-cross fs-16 close-qty-report",
                  onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.closeModal && _ctx.closeModal(...args)))
                })
              ]),
              (_ctx.fromManagement)
                ? (_openBlock(), _createBlock("div", _hoisted_3, _toDisplayString(_ctx.isNew ? _ctx.$t('sms-email-management.template.create-template') : _ctx.$t('sms-email-management.template.edit-template')), 1))
                : (_openBlock(), _createBlock("div", _hoisted_4, _toDisplayString(_ctx.$t('sms-email-management.template.send-sms-email')), 1)),
              _createVNode("div", _hoisted_5, [
                _createVNode("div", _hoisted_6, [
                  _createVNode("div", _hoisted_7, [
                    _createVNode("div", _hoisted_8, [
                      _withDirectives(_createVNode("textarea", {
                        ref: "textArea",
                        style: {"min-height":"150px"},
                        maxlength: "4000",
                        class: "col-12 bookit-textarea product-textarea resize-off form-control",
                        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.template.text = $event)),
                        required: ""
                      }, null, 512), [
                        [_vModelText, _ctx.template.text]
                      ])
                    ]),
                    (_ctx.fromManagement)
                      ? (_openBlock(), _createBlock("div", _hoisted_9, [
                          _createVNode("div", null, [
                            _createVNode("div", _hoisted_10, _toDisplayString(_ctx.$t('sms-email-management.template.template-name')) + ":", 1),
                            _withDirectives(_createVNode("input", {
                              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.template.name = $event)),
                              required: "",
                              maxlength: "255",
                              class: "bookit-input form-control h48"
                            }, null, 512), [
                              [_vModelText, _ctx.template.name]
                            ])
                          ])
                        ]))
                      : (_openBlock(), _createBlock("div", _hoisted_11, [
                          _createVNode("div", _hoisted_12, [
                            (!_ctx.useDefinedTemplateClicked)
                              ? (_openBlock(), _createBlock("div", _hoisted_13, [
                                  _createVNode("button", {
                                    onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.useDefinedTemplate())),
                                    type: "button",
                                    class: "w-100",
                                    style: {"min-height":"46px"}
                                  }, [
                                    (!_ctx.loading)
                                      ? (_openBlock(), _createBlock("span", _hoisted_14, _toDisplayString(_ctx.$t('sms-email-management.template.use-defined-template')), 1))
                                      : _createCommentVNode("", true)
                                  ])
                                ]))
                              : (_openBlock(), _createBlock("div", _hoisted_15, [
                                  _createVNode("div", _hoisted_16, [
                                    _createVNode("div", _hoisted_17, [
                                      _createVNode(_component_Multiselect, {
                                        ref: "templateOptions",
                                        modelValue: _ctx.selectedTemplate.id,
                                        "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (_ctx.selectedTemplate.id = $event)),
                                        valueProp: "id",
                                        label: "name",
                                        options: _ctx.templates,
                                        id: 'type-select-' + _ctx.selectedTemplate.id,
                                        "close-on-select": true,
                                        class: "custom-multiselect-input",
                                        onSelect: _cache[6] || (_cache[6] = ($event: any) => (_ctx.selectTemplate())),
                                        onDeselect: _cache[7] || (_cache[7] = ($event: any) => (_ctx.selectTemplate()))
                                      }, {
                                        caret: _withId(() => [
                                          _hoisted_18
                                        ]),
                                        _: 1
                                      }, 8, ["modelValue", "options", "id"])
                                    ])
                                  ])
                                ])),
                            (_ctx.loading)
                              ? (_openBlock(), _createBlock("div", _hoisted_19))
                              : _createCommentVNode("", true),
                            _createVNode("div", _hoisted_20, [
                              _createVNode("button", {
                                disabled: !_ctx.isValidTemplate,
                                onClick: _cache[8] || (_cache[8] = 
//@ts-ignore
(...args) => (_ctx.ShowInputTemplateName && _ctx.ShowInputTemplateName(...args))),
                                type: "button",
                                class: "w-100"
                              }, _toDisplayString(_ctx.$t('sms-email-management.template.save-template')), 9, ["disabled"])
                            ])
                          ])
                        ])),
                    _createVNode("div", _hoisted_21, [
                      _createVNode("button", {
                        onClick: _cache[9] || (_cache[9] = ($event: any) => (_ctx.fileInput.click())),
                        type: "button",
                        class: "col-12"
                      }, _toDisplayString(_ctx.$t('sms-email-management.template.attachments')), 1),
                      (_ctx.template.attachments && _ctx.template.attachments.length > 0)
                        ? (_openBlock(), _createBlock("div", _hoisted_22, [
                            (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.template.attachments, (attachment, index) => {
                              return (_openBlock(), _createBlock("div", {
                                key: index,
                                class: "download-file-container"
                              }, [
                                _createVNode("div", _hoisted_23, [
                                  _createVNode("i", {
                                    class: [_ctx.getDocIcon(attachment.name), "icon-f fs-24"]
                                  }, null, 2),
                                  _createVNode("span", _hoisted_24, _toDisplayString(attachment.name), 1)
                                ]),
                                _createVNode("span", {
                                  onClick: ($event: any) => (_ctx.removeFile(index, true)),
                                  class: "remove-file-button"
                                }, null, 8, ["onClick"])
                              ]))
                            }), 128))
                          ]))
                        : _createCommentVNode("", true),
                      _createVNode("input", {
                        type: "file",
                        onChange: _cache[10] || (_cache[10] = 
//@ts-ignore
(...args) => (_ctx.uploadFile && _ctx.uploadFile(...args))),
                        multiple: "",
                        ref: "fileInput",
                        style: {"display":"none"}
                      }, null, 544),
                      (_ctx.files && _ctx.files.length > 0)
                        ? (_openBlock(), _createBlock("div", _hoisted_25, [
                            (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.files, (file, index) => {
                              return (_openBlock(), _createBlock("div", {
                                key: index,
                                class: "download-file-container"
                              }, [
                                _createVNode("div", _hoisted_26, [
                                  _createVNode("i", {
                                    class: [_ctx.getDocIcon(file.name), "icon-f fs-24"]
                                  }, null, 2),
                                  _createVNode("span", _hoisted_27, _toDisplayString(file.name), 1)
                                ]),
                                _createVNode("span", {
                                  onClick: ($event: any) => (_ctx.removeFile(index, false)),
                                  class: "remove-file-button"
                                }, null, 8, ["onClick"])
                              ]))
                            }), 128))
                          ]))
                        : _createCommentVNode("", true)
                    ])
                  ]),
                  _createVNode("div", _hoisted_28, [
                    _createVNode("div", _hoisted_29, [
                      _createVNode("div", null, [
                        _createVNode(_component_CheckBoxInput, {
                          modelValue: _ctx.template.sendSms,
                          "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => (_ctx.template.sendSms = $event)),
                          singleLine: true
                        }, {
                          default: _withId(() => [
                            _createVNode("div", _hoisted_30, _toDisplayString(_ctx.$t('sms-email-management.sms.label')), 1)
                          ]),
                          _: 1
                        }, 8, ["modelValue"])
                      ]),
                      _withDirectives(_createVNode("div", _hoisted_31, [
                        _createVNode("div", _hoisted_32, [
                          _createVNode("div", _hoisted_33, [
                            _createVNode("div", _hoisted_34, [
                              _createVNode("div", _hoisted_35, _toDisplayString(_ctx.$t('sms-email-management.template.sms-sender-name')) + ": ", 1),
                              _withDirectives(_createVNode("input", {
                                disabled: "",
                                "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => (_ctx.template.smsSenderName = $event)),
                                required: _ctx.template.sendSms,
                                maxlength: "255",
                                class: "bookit-input form-control h48"
                              }, null, 8, ["required"]), [
                                [_vModelText, _ctx.template.smsSenderName]
                              ])
                            ])
                          ])
                        ])
                      ], 512), [
                        [_vShow, _ctx.template.sendSms]
                      ])
                    ])
                  ]),
                  _createVNode("div", _hoisted_36, [
                    _createVNode("div", _hoisted_37, [
                      _createVNode("div", null, [
                        _createVNode(_component_CheckBoxInput, {
                          modelValue: _ctx.template.sendEmail,
                          "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => (_ctx.template.sendEmail = $event)),
                          singleLine: true
                        }, {
                          default: _withId(() => [
                            _createVNode("div", _hoisted_38, _toDisplayString(_ctx.$t('sms-email-management.email.label')), 1)
                          ]),
                          _: 1
                        }, 8, ["modelValue"])
                      ]),
                      _withDirectives(_createVNode("div", _hoisted_39, [
                        _createVNode("div", _hoisted_40, [
                          _createVNode("div", _hoisted_41, [
                            _createVNode("div", _hoisted_42, [
                              _createVNode("div", _hoisted_43, _toDisplayString(_ctx.$t('sms-email-management.template.email-sender-name')) + ": ", 1),
                              _withDirectives(_createVNode("input", {
                                required: _ctx.template.sendEmail,
                                "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => (_ctx.template.emailSenderName = $event)),
                                maxlength: "255",
                                class: "bookit-input form-control h48"
                              }, null, 8, ["required"]), [
                                [_vModelText, _ctx.template.emailSenderName]
                              ])
                            ]),
                            _createVNode("div", _hoisted_44, [
                              _createVNode("div", _hoisted_45, _toDisplayString(_ctx.$t('sms-email-management.template.email-subject')) + ":", 1),
                              _withDirectives(_createVNode("input", {
                                required: _ctx.template.sendEmail,
                                "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => (_ctx.template.emailSubject = $event)),
                                maxlength: "255",
                                class: "bookit-input form-control h48"
                              }, null, 8, ["required"]), [
                                [_vModelText, _ctx.template.emailSubject]
                              ])
                            ])
                          ])
                        ])
                      ], 512), [
                        [_vShow, _ctx.template.sendEmail]
                      ])
                    ])
                  ]),
                  _withDirectives(_createVNode("div", _hoisted_46, [
                    _createVNode("div", _hoisted_47, [
                      _createVNode("div", _hoisted_48, [
                        _createVNode("div", _hoisted_49, [
                          _withDirectives(_createVNode("input", {
                            style: {"margin-block":"15px"},
                            type: "checkbox",
                            class: "toggle",
                            checked: _ctx.template.isRtl,
                            "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => (_ctx.template.isRtl = $event))
                          }, null, 8, ["checked"]), [
                            [_vModelCheckbox, _ctx.template.isRtl]
                          ]),
                          _createVNode("span", _hoisted_50, _toDisplayString(_ctx.$t('sms-email-management.template.force-rtl-text')), 1)
                        ])
                      ])
                    ])
                  ], 512), [
                    [_vShow, _ctx.template.sendEmail]
                  ]),
                  _createVNode("div", _hoisted_51, [
                    _createVNode("button", _hoisted_52, _toDisplayString(_ctx.fromManagement ? _ctx.$t('button.save') : _ctx.$t('button.send')), 1),
                    _createVNode("button", {
                      class: "cancel-template-button",
                      type: "button",
                      onClick: _cache[17] || (_cache[17] = 
//@ts-ignore
(...args) => (_ctx.closeModal && _ctx.closeModal(...args)))
                    }, _toDisplayString(_ctx.$t('button.cancel')), 1)
                  ])
                ]),
                _createVNode("div", _hoisted_53, [
                  _createVNode("div", _hoisted_54, [
                    _createVNode("div", _hoisted_55, [
                      _createVNode("span", _hoisted_56, _toDisplayString(_ctx.$t('sms-email-management.template.click-and-add')) + ": ", 1),
                      _createVNode("div", null, [
                        _createVNode("div", null, [
                          (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.keys, (item) => {
                            return (_openBlock(), _createBlock("span", {
                              key: item.key,
                              onClick: ($event: any) => (_ctx.addKeyToText(item.key)),
                              class: "template-key-option"
                            }, _toDisplayString(_ctx.$t(item.label)), 9, ["onClick"]))
                          }), 128))
                        ])
                      ])
                    ])
                  ])
                ])
              ])
            ]))
          : _createCommentVNode("", true)
      ], 544)
    ]),
    _: 1
  }, 8, ["isOpen"]))
})